import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import {Router, ActivatedRoute} from '@angular/router';
import { BaseService } from 'src/app/core/services/base.service';
import { Config } from 'src/app/config/constants';

@Component({
  selector: 'app-policy-search-detail',
  templateUrl: './policy-search-detail.component.html',
  styleUrls: ['./policy-search-detail.component.scss'],
  providers: [DatePipe],
})

export class PolicySearchDetailComponent implements OnInit {

  showSearchedPolicy:boolean=false;
  showPolicyDetails:boolean=false;
  showPolicySearch:boolean=true;
  showRefundPolicy:boolean=false;
  showAudtiLogs:boolean=false;
  selectedPolicyId:any;
  editcreditCardDetails: any=[];
  cardType:any
  agentId: any;
sslCardNumber
sslCardShortDescription:any
sslCardType:any
sslCvv2Response:any
sslExpDate:any
sslTransactionType:any
minDate = new Date();
startDate: any;
minDate1 = new Date()
minDateArrival= new Date();
showarrivalDateInCanadaPopup:boolean=false;
createdDate:any;
loggedInUserName:any;
hideQuotePurchase:any;
  viewMoreIndex: any;
  policyDataPrevNext:any=[];
  purchaserAddress1c: any;
  checkOVRInAgencyCode: any;
  msgfinal: string;
  msg: string;
  agentIdActive: string;
  leadsId: any;
  agentIdInactiveNewAgency: boolean=false;
  leadStatus: any;
  constructor(public userservice: UserService,private datePipe: DatePipe,private base: BaseService,private config:Config,public user: UserService,private router: Router) { }

  ngOnInit() {
    this.policyId=localStorage.getItem('tlSalesAdminPolicyAdmin');
    this.loggedInUserName=sessionStorage.getItem("username");
    this.hideQuotePurchase=sessionStorage.getItem('hideQuotePurchase');
    this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode');
    this.policyDataPrevNext=JSON.parse(sessionStorage.getItem('policyData'));
    this.getPolicyByIdSalesAdmin();
    this.addFirstValueTraveller();
    this.minDate.setHours(0, 0, 0, 0);
    this.minDate1.setHours(0, 0, 0, 0);
    this.minDateArrival.setHours(0, 0, 0, 0);
    this.minDateArrival.setHours(0, 0, 0, 0);
    this.leadsId=sessionStorage.getItem('leadId');
this.agentId=sessionStorage.getItem('agentIdSalesPortal');
this.getLeadAgentsCodes();
    this.insuredPerson();
    this.getcountryListing();
    this.getAllProvinces();
    this.getDashboard();
    let morningSlotDate = new Date();
    this.createdDate = this.datePipe.transform(morningSlotDate, "MM/dd/yyyy");
  }
  applicationEndDate ="";
  applicationStartDate ="";
  creditCardNumber ="";
  departureEndDate ="";
  departureStartDate ="";
  effectiveEndDate ="";
  effectiveStartDate ="";
  firstName ="";
  lastName ="";
  policyNumber ="";
  agencyCode="";
  onClickPolicySearch(){
    this.showSearchedPolicy = true;
    if(!this.policyNumber && !this.lastName && !this.firstName && !this.effectiveStartDate
      && !this.departureStartDate && !this.departureEndDate && !this.creditCardNumber && !this.applicationStartDate
      && !this.applicationEndDate){
        this.getAllPolicyForSalesAdmin();
      }else{
        this.searchFilterPolicy();
      }
  }
  policyId: any;
  policyInsureds=[];
  getPolicyData=[];
  selectedPlans=[];
  policyQuestionAnswers=[];
  transactionDetails=[];
  policyNumber1: any;
  txnId: any;
  refundPolicyReason: any;
  onClickPolicyNumber(id,number){
    this.showPolicyDetails=true;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
    this.showPolicySearch=false;
    this.selectedPolicyId=this.policyId;
    this.policyNumber = localStorage.getItem('policyNumber');
    this.userservice.getPolicyById1(this.policyId).pipe()
    .subscribe(
        data => {
    this.policyInsureds = data.data.policyInsureds;
    this.selectedPlans = data.data.plans;
    this.policyQuestionAnswers = data.data.policyQuestionAnswers;
    this.getPolicyData.push(data.data);
    this.transactionDetails = data.data.transactions;
    if(data.data.transactions != null ){
      this.txnId = data.data.transactions[0].transactionPaymentDetails[0].sslTxnId
    }
        },error=>{},()=>{});
     this.getPolicyByIdSalesAdmin();
  }
  backToPolicySearch(){
    // this.showSearchedPolicy=true;
    // this.showPolicyDetails=false;
    // this.showPolicySearch=true;
    // this.showRefundPolicy=false;
    // this.showAudtiLogs=false;
    // this.showChangePolicy=false;
    // this.showEditBillingInformation=false;
    this.router.navigateByUrl('/dashboard/policy-search');
  }
  onClickRefundPolicy(){
    // this.showSearchedPolicy=false;
    // this.showPolicyDetails=false;
    // this.showPolicySearch=false;
    // this.showRefundPolicy=true;
    // this.showAudtiLogs=false;
    if(this.policyIDDetail[0].status.status!="Refunded" && this.showBtnChange==true && (this.agentIdActive==='true' || this.agentIdInactiveNewAgency==true)){
    this.router.navigateByUrl('/dashboard/policy-full-refund');
  }
    // setTimeout(() =>
    //   {
    //     window.location.reload();
    //   },
    //   50);
  }

  showRemove:boolean=false;
  insuredCount=1;
  numberOFInsured:any=0;
  incNumberOfInsured(){
    // if(this.numberOFInsured !=9){
    //   this.numberOFInsured++;
    // }
    if(this.insuredCount !=9){
      this.insuredCount++
      this.numberOFInsured =this.insuredCount;
      this.addFirstValueTraveller();
      if(this.insuredCount>1){
        this.showRemove=true;
      }else{
        this.showRemove=false;
      }
    }
  }
  minusNumberOfInsured(){
    // if(this.numberOFInsured < 10 && this.numberOFInsured > 0){
    //   this.numberOFInsured--;
    // }
    if(this.insuredCount < 10 && this.insuredCount > 1){
      this.numberOFInsured = this.insuredCount
      this.insuredCount--
      this.travellerInfo.splice(this.insuredCount, 1);
      if(this.insuredCount >1){
        this.showRemove=true;
       }else{
         this.showRemove=false;
       }
    }
  }

  minusNumberOfInsuredShort(i){
    if(this.insuredCount < 10 && this.insuredCount > 0){
      this.numberOFInsured--;
      this.insuredCount--
      this.travellerInfo.splice(i, 1);
      if(this.insuredCount>1){
        this.showRemove=true;
       }else{
         this.showRemove=false;
       }
    }
  }

  // minDate = new Date();
  // minDate1 = new Date()
  // minDateArrival= new Date();
  startDateFlag: boolean=false;
  // startDate: any;

  callStartDateFunction(event){
  if(this.startDate){
    this.startDateFlag=false;
    this.minDate=this.startDate;
    this.minDateArrival=this.startDate;
    for(let i=0;i<this.travellerInfo.length;i++){
        this.travellerInfo[i].arrivalDateOfCanada=null;
        this.travellerInfo[i].waitPeroid=null;
    }
  if(this.expiryDate){
      const dateTwo = new Date(new Date(this.startDate).setDate(this.startDate.getDate() + this.calculatedDays));
      this.expiryDate=dateTwo;
      this.minDateArrival = new Date(this.startDate)
    }
    }
    for(let i=0;i<this.travellerInfo.length;i++){
      if(!this.startDate){
        this.travellerInfo[i].arrivalDateOfCanada=null;
        this.travellerInfo[i].waitPeroid=null;
      }
    }
  }

  errorNegative:boolean=false;
  expiryDateFlag: boolean=false;
  expiryDate: any;
  calculatedDays: any=0;
  callExpiryDateFunction(event){
    // this.startDateFlag=false;
    if(this.calculatedDays<0){
      this.errorNegative=true;
    }else{
      this.errorNegative=false;
    if(this.expiryDate){
    var Time = this.expiryDate.getTime() - this.startDate.getTime();
    var Days = Time / (1000 * 3600 * 24); //Diference in Days
    this.calculatedDays=Days;
    this.expiryDateFlag=false;
    }}
  }

  callCalculatedDaysFunction(){
    if(this.calculatedDays<0){
      this.errorNegative=true;
    }else{
      this.errorNegative=false;
    if(this.startDate){
    const dateTwo = new Date(new Date(this.startDate).setDate(this.startDate.getDate() + parseInt(this.calculatedDays)));
    this.expiryDate=dateTwo;
    }else{
      window.alert("Need valid start date before adding no of days.")
    }
    }
  }

dobFlag: boolean = false;
ageErrorCross: boolean=false;
callDateOfBirth(event){
  for(let i=0;i<this.travellerInfo.length;i++){
    var timeDiff = Math.abs(Date.now() - this.travellerInfo[i].dateOfBirth.getTime());
    var ageCalculate = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
    this.travellerInfo[i].age=ageCalculate;
    if(this.travellerInfo[i].age > 69){
      this.ageErrorCross = true;
    }else{
      this.ageErrorCross = false;
    }
    this.dobFlag=false;
  }
}

innerPop: boolean=false;
selectedQuestionAns1: any;
currentIndex: any=0;
arrivalDateCanadaFlag: boolean=false;
callArriveCanadaDate(event){
  if(this.startDate){
  for(let i=0;i<this.travellerInfo.length;i++){
    var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime();
    var Days = Time / (1000 * 3600 * 24); //Diference in Days
    if(Days>=1 && Days <=30){
      this.showarrivalDateInCanadaPopup=true;
      this.currentIndex = i
    }else if(Days>=30){
      this.showarrivalDateInCanadaPopup=true;
      this.currentIndex = i
    }
    else{
      this.travellerInfo[i].waitPeroid="None";
      this.showarrivalDateInCanadaPopup=false;
      this.currentIndex = i
    }
  }
  this.arrivalDateCanadaFlag=false;
}else{
  window.alert("Need valid expiry/start date to calculate the wait period of your policy.")
  for(let i=0;i<this.travellerInfo.length;i++){
      this.travellerInfo[i].arrivalDateOfCanada=null;
    }
}
}
  travellerInfo:any[]=[];
  addFirstValueTraveller(){
    var obj={};
    obj["dateOfBirth"]="";
    obj["age"]="";
    obj["arrivalDateOfCanada"]="";
    obj["waitPeroid"]="";
    this.travellerInfo.push(obj);
    this.numberOFInsured=1;
  }

  onClickQuestion1(data){
    if(data == "Yes"){
    this.innerPop=true;
    }else{
      for(let i=0;i<this.travellerInfo.length;i++){
        var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime();
        var Days = Time / (1000 * 3600 * 24); //Diference in Days
        if(Days>=1 && Days <=30  && this.currentIndex == i){
          this.showarrivalDateInCanadaPopup=true;
          this.travellerInfo[i].waitPeroid="48 hours for a sickness. 24 hours for an Injury";
        }else if(Days>=30  && this.currentIndex == i){
          this.showarrivalDateInCanadaPopup=true;
          this.travellerInfo[i].waitPeroid="7 days for a Sickness, 24 hours for an injury";
        }
      }
    this.innerPop=false;
    }
    }


    onClickQuestion2(data){
      if(data == "Yes"){
        for(let i=0;i<this.travellerInfo.length;i++){
          var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime();
          var Days = Time / (1000 * 3600 * 24); //Diference in Days
          if(Days>=1 && Days <=30  && this.currentIndex == i){
            this.showarrivalDateInCanadaPopup=true;
            this.travellerInfo[i].waitPeroid="None";
          }else if(Days>=30  && this.currentIndex == i){
            this.showarrivalDateInCanadaPopup=true;
            this.travellerInfo[i].waitPeroid="None";
          }

        }
        }else{
          for(let i=0;i<this.travellerInfo.length;i++){
            var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime();
            var Days = Time / (1000 * 3600 * 24); //Diference in Days
            if(Days>=1 && Days <=30 && this.currentIndex == i){
              this.showarrivalDateInCanadaPopup=true;
              this.travellerInfo[i].waitPeroid="48 hours for a sickness. 24 hours for an Injury";
            }else if(Days>=30  && this.currentIndex == i){
              this.showarrivalDateInCanadaPopup=true;
              this.travellerInfo[i].waitPeroid="7 days for a Sickness, 24 hours for an injury";
            }

          }    }
    }

    selectedQuestionAns2: any;
modalCloseQuestion(){
  this.showarrivalDateInCanadaPopup=false;
  this.selectedQuestionAns1=undefined;
  this.selectedQuestionAns2=undefined;
  this.innerPop=false;
}

selectedQuestionprovince1: any;
selectedQuestionlanguages1: any;
planQuoteResponses=[];
startDateShow=""
expiryDateShow: any;
resdentShowShow: any;
daysToshow: any;
travellerInformation=[];
qestionInfoArray=[];
postCallStep1(){
  var flag=true;
  if(!this.expiryDate){this.expiryDateFlag=true;flag=false}else{this.expiryDateFlag=false;flag=true}
  if(!this.startDate){this.startDateFlag=true;flag=false}else{this.startDateFlag=false;flag=true}
  if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false;flag=true}
  if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false;flag=true}
  if(!this.ageErrorCross){flag=false}else{flag=true}
   this.expiryDate = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
   this.startDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
  //  for(let i=0;i<this.travellerInfo.length;i++){
  //   this.travellerInfo[i].arrivalDateOfCanada = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
  //   this.travellerInfo[i].dateOfBirth = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd");
  //  }
    if (flag == true) {

      const request =
      {
    "agentId": this.agentId,
    "declaration": true,
    "deductableOptions": [
      {
        "amount": 0,
        "createdAt": "2022-04-27T05:08:15.125Z",
        "createdBy": "string",
        "id": 0,
        "lastModifiedBy": "string",
        "option": "string",
        "reduceAmount": 0,
        "updatedAt": "2022-04-27T05:08:15.125Z"
      }
    ],
    "language": this.selectedQuestionlanguages1,
    "noOfDays": this.calculatedDays,
    "optionalInformation": {
      "agentNote": "string",
      "beneficiary": "string",
      "comment": "string"
    },
    "paymentInformation": {
      "amount": 0,
      "cardNumber": "string",
      "cardType": "string",
      "cvv": "string",
      "expiryDate": "string"
    },
    "primaryAddress": {
      "address1": "string",
      "address2": "string",
      "city": "string",
      "postalCode": "string",
      "province":"string"
    },
    "purchaserAddressSame": true,
    "questionsansers": [

    ],
    "residentOf": this.selectedQuestionprovince1,
    "returnDate": this.expiryDate,
    "secondaryAddress": {
      "address1": "string",
      "address2": "string",
      "city": "string",
      "postalCode": "string",
      "province":"string"
    },
    "selectedPlan": {},
    "startDate": this.startDate,
    "travellerInformation": this.travellerInfo,
    "travelllerDetails": [
      {
        "arrivalDateInCanada": "",
        "country": "",
        "dateOfBirth": "",
        "dayTimePhone": "",
        "departureCity": "",
        "emailAddress": "",
        "firstName": "",
        "insitute": "",
        "language": "",
        "lastName": ""
      }
    ],
    "visitorsToCanada": "yes",
    "purchaserInformation":{
      "country": "",
      "emailAddress": "",
      "firstName": "",
      "language": "",
      "lastName": "",
      "phoneNumber1": "",
      "phoneNumber2": "",
      "postalCode": "",
      "province": "",
      "purchaserAddress": {
        "address1": "",
        "address2": "",
        "city": "",
        "postalCode": ""
    }}
       }
      this.base.callPostService(this.config.postApistep1, request).subscribe((data: any) => {
      this.onClickToShowPlanInfo();
      this.planQuoteResponses = data.data.planQuoteResponses;
      this.startDateShow = data.data.salesRequest.startDate;
      this.expiryDateShow=data.data.salesRequest.returnDate;
      this.resdentShowShow=data.data.salesRequest.residentOf;
      this.daysToshow = this.calculatedDays;
      this.travellerInformation = data.data.salesRequest.travellerInformation;
      this.qestionInfoArray = data.data.questions;
      this.qestionInfoArrayShow.push(this.qestionInfoArray[0]);
         }, error => {

      }, () => { });
  }}
  qestionInfoArrayShow=[];

  onClickToShowPlanInfo(){

    window.scrollTo(0,0);
  var flag=true;
  if(!this.expiryDate){this.expiryDateFlag=true;flag=false}else{this.expiryDateFlag=false;flag=true}
  if(!this.startDate){this.startDateFlag=true;flag=false}else{this.startDateFlag=false;flag=true}
  if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false;flag=true}
  if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false;flag=true}
   this.expiryDate = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
   this.startDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
   this.step2SaveApiCall()
  //  for(let i=0;i<this.travellerInfo.length;i++){
  //   this.travellerInfo[i].arrivalDateOfCanada = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
  //   this.travellerInfo[i].dateOfBirth = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd");
  //  }

    if (flag == true) {
      const request =
      {
     "agentId": this.agentId,
     "declaration": true,
     "deductableOptions": [
      {
        "amount": 0,
        "createdAt": "2022-04-27T05:08:15.125Z",
        "createdBy": "string",
        "id": 0,
        "lastModifiedBy": "string",
        "option": "string",
        "reduceAmount": 0,
        "updatedAt": "2022-04-27T05:08:15.125Z"
      }
     ],
     "language": this.selectedQuestionlanguages1,
     "noOfDays": this.calculatedDays,
     "optionalInformation": {
      "agentNote": "string",
      "beneficiary": "string",
      "comment": "string"
     },
     "paymentInformation": {
      "amount": 0,
      "cardNumber": "string",
      "cardType": "string",
      "cvv": "string",
      "expiryDate": "string"
     },
     "primaryAddress": {
      "address1": "string",
      "address2": "string",
      "city": "string",
      "postalCode": "string",
      "province":"string"
     },
     "purchaserAddressSame": true,
     "questionsansers": [

     ],
     "residentOf": this.selectedQuestionprovince1,
     "returnDate": this.expiryDate,
     "secondaryAddress": {
      "address1": "string",
      "address2": "string",
      "city": "string",
      "postalCode": "string",
      "province":"string"
     },
     "selectedPlan": {},
     "startDate": this.startDate,
     "travellerInformation": this.travellerInfo,
     "travelllerDetails": [
      {
        "arrivalDateInCanada": "",
        "country": "",
        "dateOfBirth": "",
        "dayTimePhone": "",
        "departureCity": "",
        "emailAddress": "",
        "firstName": "",
        "insitute": "",
        "language": "",
        "lastName": ""
      }
     ],
     "visitorsToCanada": "yes",
     "purchaserInformation":{
      "country": "",
      "emailAddress": "",
      "firstName": "",
      "language": "",
      "lastName": "",
      "phoneNumber1": "",
      "phoneNumber2": "",
      "postalCode": "",
      "province": "",
      "purchaserAddress": {
        "address1": "",
        "address2": "",
        "city": "",
        "postalCode": ""
     }}
       }

      this.base.callPostService(this.config.postApistep1, request).subscribe((data: any) => {
      this.planQuoteResponses = data.data.planQuoteResponses;
      this.startDateShow=data.data.salesRequest.startDate;
      this.expiryDateShow=data.data.salesRequest.returnDate;
      this.resdentShowShow=data.data.salesRequest.residentOf;
      this.daysToshow = this.calculatedDays;
      this.travellerInformation = data.data.salesRequest.travellerInformation;
      // for(let i=0;i<data.data.salesRequest.travellerInformation.length;i++){
      //   var obj={}
      //   obj["age"]=data.data.salesRequest.travellerInformation[i].age
      //   obj["arrivalDateOfCanada"]=data.data.salesRequest.travellerInformation[i].arrivalDateOfCanada
      //   obj["dateOfBirth"]=data.data.salesRequest.travellerInformation[i].dateOfBirth
      //   obj["waitPeroid"]=data.data.salesRequest.travellerInformation[i].waitPeroid
      //   obj["checkToggleButtonYesbtn"]="Active1"
      //   obj["checkToggleButtonNobtn"]="Active1"
      //   this.travellerInformation.push(obj)
      // }
      this.qestionInfoArray = data.data.questions;
      this.qestionInfoArrayShow=[];
      this.qestionInfoArrayShow.push(this.qestionInfoArray[0]);
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=true;
      //this.showChangePolicyStepTwoB=true;
       this.showChangePolicyStepThree=false;
       this.showChangePolicyStepThreeAdminFee=false;
      //this.showChangePolicyStepThreeAdminFee=true;  //new
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
      // this.showChooseQuote=false;
      // this.showIntStudPlan=true;
      // this.showIntStudPlanStep1=false;
      // this.showIntStudPlanPlanOption=true;
      // this.showQuestionnaire=false;
      // this.showContactInfo=false;
      // this.showPayment=false;
      // this.showPaymentsDetails=false;
         }, error => {

      }, () => { });
  }
     }


  showChangePolicy:boolean=false;
  showChangePolicyStepOne:boolean=false;
  showChangePolicyStepTwo:boolean=false;
  showChangePolicyStepTwoB:boolean=false;
  showChangePolicyStepThree:boolean=false;
  showChangePolicyStepThreeAdminFee:boolean=false;
  showChangePolicyStepFour:boolean=false;
  showChangePolicyStepFive:boolean=false;
  onClickChangePolicy(){
    // window.scrollTo(0, 0);
    // this.showChangePolicy=true;
    // this.showChangePolicyStepOne=true;
    // this.showChangePolicyStepTwo=false;
    // this.showChangePolicyStepTwoB=false;
    // this.showChangePolicyStepThree=false;
    // this.showChangePolicyStepThreeAdminFee=false;
    // this.showChangePolicyStepFour=false;
    // this.showChangePolicyStepFive=false;
    // this.showSearchedPolicy=false;
    // this.showPolicyDetails=false;
    // this.showPolicySearch=false;
    // this.showRefundPolicy=false;
    // this.showAudtiLogs=false;
    if(this.policyIDDetail[0].status.status!="Refunded" && this.showBtnChange==true && (this.agentIdActive==='true' || this.agentIdInactiveNewAgency==true)){
    this.router.navigateByUrl('/dashboard/change-policy');
    setTimeout(() =>
      {
        window.location.reload();
      },
      20);
    }
  }
  onClickChangePolicyStepOneNext(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=true;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=false;
    this.showChangePolicyStepThreeAdminFee=false;
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
    var flag=true;
if(!this.expiryDate){this.expiryDateFlag=true;flag=false}else{this.expiryDateFlag=false;flag=true}
if(!this.startDate){this.startDateFlag=true;flag=false}else{this.startDateFlag=false;flag=true}
if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false;flag=true}
if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false;flag=true}
 this.expiryDate = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
 this.startDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");

  }
  purchaserAddress2: any;
  firstNameFlag: boolean=false;
  lastNameFlag: boolean=false;
  InstituteFlag: boolean=false;
  CountryFlag: boolean=false;

  removeFirstNameError(){
    this.firstNameFlag=false;
  }
  removeLastNameError(){
   this.lastNameFlag=false;
 }
 removeInstituteNameError(){
   this.InstituteFlag=false;
 }
 removeCountryNameError(){
   this.CountryFlag=false;
 }

 countryListing: any=[];
getcountryListing(){
  this.user.getCountryDropdown().subscribe((data:any) =>{
   this.countryListing = data.data;
  },error=>{{
  //handle Exception from Server 404,401
  }},()=>{});
}


  onClickChangePolicyStepOneBack(){
    window.scrollTo(0, 0);
    this.showChangePolicy=false;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=false;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=false;
    this.showChangePolicyStepThreeAdminFee=false;
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=true;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  onClickChangePolicyStepTwoNext(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=true;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=true;
    this.showChangePolicyStepThreeAdminFee=false;
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  onClickChangePolicyStepTwoBack(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=true;
    this.showChangePolicyStepTwo=false;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=false;
    this.showChangePolicyStepThreeAdminFee=false;
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  onClickChangePolicyStepTwoBNext(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=false;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=true;
    //this.showChangePolicyStepThreeAdminFee=false;
    this.showChangePolicyStepThreeAdminFee=true   //new line added
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  onClickChangePolicyStepTwoBBack(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=true;
    this.showChangePolicyStepTwoB=false;
    //this.showChangePolicyStepTwoB=true;       //new line
    this.showChangePolicyStepThree=false;
    this.showChangePolicyStepThreeAdminFee=false;
    //this.showChangePolicyStepThreeAdminFee=true;
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  onClickChangePolicyStepThreeNext(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=false;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=false;
    this.showChangePolicyStepThreeAdminFee=true;
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  // onClickChangePolicyStepThreeBack(){
  //   window.scrollTo(0, 0);
  //   this.showChangePolicy=true;
  //   this.showChangePolicyStepOne=false;
  //   this.showChangePolicyStepTwo=false;
  //   this.showChangePolicyStepTwoB=true;
  //   this.showChangePolicyStepThree=false;
  //   this.showChangePolicyStepThreeAdminFee=false;
  //   this.showChangePolicyStepFour=false;
  //   this.showChangePolicyStepFive=false;
  //   this.showSearchedPolicy=false;
  //   this.showPolicyDetails=false;
  //   this.showPolicySearch=false;
  //   this.showRefundPolicy=false;
  // }
  onClickChangePolicyStepThreeBack(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=false;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=true;
    this.showChangePolicyStepThreeAdminFee=false;
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  onClickChangePolicyStepThreeAdminTreeNext(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=false;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=false;
    this.showChangePolicyStepThreeAdminFee=false;
    this.showChangePolicyStepFour=true;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  onClickChangePolicyStepThreeAdminTreeBack(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=true;
    //this.showChangePolicyStepTwoB=false;
    //this.showChangePolicyStepTwoB=true;     //new
    this.showChangePolicyStepThree=false;
    this.showChangePolicyStepThreeAdminFee=false;
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  onClickChangePolicyStepFourNext(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=false;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=false;
    this.showChangePolicyStepThreeAdminFee=false;
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=true;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  onClickChangePolicyStepFourBack(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=false;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=false;
    this.showChangePolicyStepThreeAdminFee=true;
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  onClickChangePolicyStepFiveNext(){
    window.scrollTo(0, 0);
    Swal.fire('',"Successfully Sent",'success')
    this.showChangePolicy=false;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=false;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=false;
    this.showChangePolicyStepThreeAdminFee=false;
    this.showChangePolicyStepFour=false;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=true;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  onClickChangePolicyStepFiveBack(){
    window.scrollTo(0, 0);
    this.showChangePolicy=true;
    this.showChangePolicyStepOne=false;
    this.showChangePolicyStepTwo=false;
    this.showChangePolicyStepTwoB=false;
    this.showChangePolicyStepThree=false;
    this.showChangePolicyStepThreeAdminFee=false;
    this.showChangePolicyStepFour=true;
    this.showChangePolicyStepFive=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }
  showPaymentHistoryPopup:boolean=false;
  showEditBillingInformation:boolean=false;
  onClickEditBillingInfo(){
    // this.editBilling(this.policyIDDetail[0].creditCardDetails)
    // this.showEditBillingInformation=true;
    // this.showSearchedPolicy=false;
    // this.showPolicyDetails=false;
    // this.showPolicySearch=false;
    // this.showAudtiLogs=false;
    // this.showRefundPolicy=false;
    // this.showChangePolicy=false;
    this.router.navigateByUrl('/dashboard/sales-admin-edit-billing-info');
  }
  backToPolicyDetails(){
    this.showEditBillingInformation=false;
    this.showSearchedPolicy=false;
    this.showPolicyDetails=true;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
    this.showChangePolicy=false;
  }
  userPolicyDetails=[];
  policyTotal:any;
  onSelectSizePage:any=30;
  p:any=0;
  policyPageNo:any=0;
  getAllPolicyForSalesAdmin(){
    this.userservice.getAllPolicyForSalesAdmin().pipe()
    .subscribe(
        data => {
          if(data.data.userPolicyDetails.length!=0){
            this.userPolicyDetails=data.data.userPolicyDetails;
            this.policyTotal=data.data.total;
          }
        },error=>{},()=>{});
  }
  pageChnageDone(data){
    this.policyPageNo = data-1;
    this.userservice.getAllPolicyForSalesAdminByPage(this.policyPageNo,this.onSelectSizePage).pipe()
    .subscribe(
        data => {
          if(data.data.userPolicyDetails.length!=0){
            this.userPolicyDetails=data.data.userPolicyDetails;
            this.policyTotal=data.data.total;
          }
    },error=>{},()=>{});
  }
  onPolicySortAsc(data){
    this.userservice.getAllPolicyForSalesAdminSortAsc(this.policyPageNo,this.onSelectSizePage,data).pipe()
    .subscribe(
        data => {
          if(data.data.userPolicyDetails.length!=0){
            this.userPolicyDetails=data.data.userPolicyDetails;
            this.policyTotal=data.data.total;
          }
        },error=>{},()=>{});
  }
  onPolicySortDsc(data){
    this.userservice.getAllPolicyForSalesAdminSortDesc(this.policyPageNo,this.onSelectSizePage,data).pipe()
    .subscribe(
        data => {
          if(data.data.userPolicyDetails.length!=0){
            this.userPolicyDetails=data.data.userPolicyDetails;
            this.policyTotal=data.data.total;
          }
        },error=>{},()=>{});
  }
  policyIDDetail=[];
  contactInfoFirstName:any;
  contactInfoLastName:any;
  contactInfoEmail:any;
  contactInfoLanguage:any;
  purchaserName:any;
  purchaserEmailAddress:any;
  purchaserPhone1:any;
  purchaserPhone2:any;
  purchaserlanguage:any;
  fulfillments:any;
  showBtnChange:boolean=true
  chkDate:any
  getPolicyByIdSalesAdmin(){
    this.userservice.getPolicyByIdSalesAdmin(this.policyId).pipe()
    .subscribe(
      data => {
        this.policyIDDetail=[];
        this.policyIDDetail.push(data.data);
         var chkDate1 = data.data.effectiveDate;
         this.chkDate = new Date();
        this.chkDate=this.datePipe.transform(this.chkDate, "yyyy-MM-dd");
        console.log(this.chkDate)
        if(chkDate1<=this.chkDate){
          this.showBtnChange=false
        }
        else{
          this.showBtnChange=true
        }
        this.contactInfoFirstName=data.data.policyInsureds[0].firstName;
        this.contactInfoLastName=data.data.policyInsureds[0].lastName;
        this.contactInfoEmail=data.data.purchaserEmailAddress;
        this.contactInfoLanguage=data.data.language;
        this.purchaserFirstName=data.data.purchaserFirstName;
        this.purchaserLastName=data.data.purchaserLastName;
        this.purchaserEmailAddress=data.data.purchaserEmailAddress;
        this.purchaserPhone1=data.data.purchaserPhone1;
        this.purchaserPhone2=data.data.purchaserPhone2;
        this.purchaserlanguage=data.data.language;
        this.policyNumber=data.data.policyNumber;
        this.updateContactInfoAddress1=data.data.primaryAddress1;
        this.updateContactInfoAddress2=data.data.primaryAddress2;
        this.updateContactInfoCity=data.data.primaryAddressCity;
        this.updateContactInfoPostalCode= data.data.primaryAddressPostalCode;
        this.updateContactInfoProvince= data.data.primaryAddressProvince;
        this.updatePurchaserInfoProvince= data.data.purchaserAddressProvince;
        if(this.updatePurchaserInfoProvince == "Non-Resident of Canada" || this.updatePurchaserInfoProvince== "Non Resident of Canada"){
          this.NonResidentSelected=true
        }else{
          this.NonResidentSelected=false;
        }
        this.updatePurchaserInfoAddress1=data.data.purchaserAddress1;
        this.updatePurchaserInfoAddress2=data.data.purchaserAddress2;
        this.updatePurchaserInfoCity=data.data.purchaserAddressCity;
        this.updatePurchaserInfoPostalCode= data.data.purchaserAddressPostalCode;
        
        
        if(data.data.fulfillments.length!=0){
          this.fulfillments=data.data.fulfillments
        }
    },error=>{},()=>{});
  }
  onClickPolicyNumber1(){
    this.showPolicyDetails=true;
    this.showPolicySearch=false;
    this.showRefundPolicy=false;
    this.showAudtiLogs=false;
  }

  showReasonError: boolean=false;
  removeRefundError(){
    this.showReasonError=false;
  }

  // onRefundProcessCall(){
  //   var flag = true;
  //   if(!this.refundPolicyReason)
  //   {this.showReasonError=true;flag=false}

  //   else{
  //     this.showReasonError=false;flag=true
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "you want to process the refund? ",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#2778c4 !important;',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes'
  //   }).then((result) => {
  //     if (result.isConfirmed) {

  //       if(flag){
  //         this.userservice.refundCallApi(this.policyId,this.txnId,this.refundPolicyReason).pipe()
  //         .subscribe(
  //             data => {
  //               Swal.fire('',data.message,'success');
  //             },error=>{},()=>{});
  //       }
  //     }
  //   })
  // }
  //   // var flag = true;
  //   // if(!this.refundPolicyReason){this.showReasonError=true;flag=false}else{this.showReasonError=false;flag=true}
  //   // if(flag){
  //   //   this.userservice.refundCallApi(this.policyId,this.txnId,this.refundPolicyReason).pipe()
  //   //   .subscribe(
  //   //       data => {
  //   //         Swal.fire('',data.message,'success');
  //   //       },error=>{},()=>{});
  //   // }
  // }

  searchFilterPolicy(){
  this.effectiveStartDate = this.datePipe.transform(this.effectiveStartDate, "yyyy-MM-dd");
  this.departureStartDate = this.datePipe.transform(this.departureStartDate, "yyyy-MM-dd");
  this.applicationStartDate = this.datePipe.transform(this.applicationStartDate, "yyyy-MM-dd");
  this.applicationEndDate = this.datePipe.transform(this.applicationEndDate, "yyyy-MM-dd");

    this.userservice.getFilterSearchPolicy(this.agencyCode,this.policyNumber,this.lastName,this.firstName,this.effectiveStartDate,this.departureStartDate,this.departureEndDate,this.creditCardNumber,this.applicationStartDate,this.applicationEndDate).pipe()
      .subscribe(
          data => {
            if(data.data.searchPolicyDetails.length!=0){
              this.userPolicyDetails=[]
              this.userPolicyDetails=data.data.searchPolicyDetails;
              this.policyTotal=data.data.total;
            }
          },error=>{},()=>{});
    }
    viewCOC(){
      if(this.agentIdActive==='true'){
      this.userservice.viewCOC(this.policyId).pipe()
      .subscribe(
          data => {

            var url=data.data
             var win = window.open(url, '_blank');
          },error=>{},()=>{});
        }
    }
    editBilling(creditCardDetails){

      var cardType=creditCardDetails[0].cardType
      var id=creditCardDetails[0].id
      var sslCardNumber=creditCardDetails[0].sslCardNumber
      var sslCardShortDescription=creditCardDetails[0].sslCardShortDescription
      var sslCardType=creditCardDetails[0].sslCardType
      var sslCvv2Response=creditCardDetails[0].sslCvv2Response
      var sslExpDate=creditCardDetails[0].sslExpDate
      var sslTransactionType=creditCardDetails[0].sslTransactionType
      // cardType,id,policyId,sslCardNumber,sslCardShortDescription,sslCardType,sslCvv2Response,sslExpDate,sslTransactionType
      this.userservice.editBilling(cardType,id,this.policyId,sslCardNumber,sslCardShortDescription,sslCardType,sslCvv2Response,sslExpDate,sslTransactionType).pipe()
      .subscribe(
          data => {
            // this.editcreditCardDetails=data.data
            this.cardType=data.data.cardType
            // this.id=creditCardDetails[0].id
            this.sslCardNumber=data.data.sslCardNumber
            this.sslCardShortDescription=data.data.sslCardShortDescription
            this.sslCardType=data.data.sslCardType
            this.sslCvv2Response=data.data.sslCvv2Response
            this.sslExpDate=data.data.sslExpDate
            this.sslTransactionType=data.data.sslTransactionType

          },error=>{},()=>{});
    }


    // new changes for step 2
purchaserAddress1Flag: boolean=false;
showAddressResults1: boolean=false;
purchaseEmailFlag:boolean=false;
purchasePhone1Flag: boolean=false;
purchasePostalCodeFlag:boolean=false;
purchaseCityFlag: boolean=false;
confirmEmailMatch: boolean=false;
purchaserAddress1: any;
purchaserLastName: any;
purchaserFirstName: any;
purchasePostalCode: any;
purchaseProvince: any;
purchaseCity: any;
purchasePhone1: any;
purchasePhone2: any;
purchaseEmail: any;
purchaseEmailConfirm: any;
emailNotValid: string="";
getAddress1=[];
    onClickContactInfoNext(){
      var flag=true;
      // if(!this.form4.purchaserLastName.value){flag=true;this.purchaserLastNameFlag=true}else{flag=false;this.purchaserLastNameFlag=false}
      // if(!this.form4.purchaserFirstName.value){flag=true;this.purchaserFirstNameFlag=true}else{flag=false;this.purchaserFirstNameFlag=false}
      if(!this.purchaserAddress1){flag=false;this.purchaserAddress1Flag=true}else{flag=true;this.purchaserAddress1Flag=false}
      // if(!this.form4.purchaseLanguage.value){flag=false;this.purchaseLanguageFlag=true}else{flag=true;this.purchaseLanguageFlag=false}
      if(!this.purchaseProvince){flag=false;this.purchaseProvinceFlag=true}else{flag=true;this.purchaseProvinceFlag=false}
      if(!this.purchaseCity){flag=false;this.purchaseCityFlag=true}else{flag=true;this.purchaseCityFlag=false}
      if(!this.purchasePostalCode){flag=false;this.purchasePostalCodeFlag=true}else{flag=true;this.purchasePostalCodeFlag=false}
      if(!this.purchasePhone1){flag=false;this.purchasePhone1Flag=true}else{flag=true;this.purchasePhone1Flag=false}
      // if(!this.form4.purchasePhone2.value){flag=false;this.purchasePhone2Flag=true}else{flag=true;this.purchasePhone2Flag=false}
      if(!this.purchaseEmail){flag=false;this.purchaseEmailFlag=true}else{flag=true;this.purchaseEmailFlag=false}
      if(!this.insuredPersonArray[0].firstName){flag=false;this.firstNameFlag=true}else{flag=true;this.firstNameFlag=false}
      if(!this.insuredPersonArray[0].lastName){flag=false;this.lastNameFlag=true}else{flag=true;this.lastNameFlag=false}
      if(!this.insuredPersonArray[0].insitute){flag=false;this.InstituteFlag=true}else{flag=true;this.InstituteFlag=false}
      if(!this.insuredPersonArray[0].homeCountry){flag=false;this.CountryFlag=true}else{flag=true;this.CountryFlag=false}

      window.scrollTo(0, 0);
        this.showChangePolicy=true;
        this.showChangePolicyStepOne=false;
        this.showChangePolicyStepTwo=false;
        this.showChangePolicyStepTwoB=false;
        this.showChangePolicyStepThree=true;
        this.showChangePolicyStepThreeAdminFee=false;
        this.showChangePolicyStepFour=false;
        this.showChangePolicyStepFive=false;
        this.showSearchedPolicy=false;
        this.showPolicyDetails=false;
        this.showPolicySearch=false;
        this.showRefundPolicy=false;
        this.showAudtiLogs=false;
      if (flag == true && this.confirmEmailMatch == false) {
        const request =
        {
          "agentId": this.agentId,
          "declaration": true,
          "deductableOptions": [
            {
              "amount": 0,
              "createdAt": "2022-04-27T05:08:15.125Z",
              "createdBy": "string",
              "id": 0,
              "lastModifiedBy": "string",
              "option": "string",
              "reduceAmount": 0,
              "updatedAt": "2022-04-27T05:08:15.125Z"
            }
          ],
          "language": this.selectedQuestionlanguages1,
          "noOfDays": this.calculatedDays,
          "optionalInformation": {
            "agentNote": this.comment,
            "beneficiary": this.beneficiary,
            "comment": this.agentNote
          },
          "paymentInformation": {
            "amount": 0,
            "cardNumber": "string",
            "cardType": "string",
            "cvv": "string",
            "expiryDate": "string"
          },
          "primaryAddress": {
            "address1": "",
            "address2": "",
            "city": "",
            "postalCode": "",
            "province": ""
          },
          "purchaserAddressSame": true,
          "questionsansers": this.questionAnsArray,
          "residentOf": this.selectedQuestionprovince1,
          "returnDate": this.expiryDate,
          "secondaryAddress": {
            "address1": "string",
            "address2": "string",
            "city": "string",
            "postalCode": "string",
            "province":"string"
          },
          "selectedPlan": this.selectedPlanSend,
          "startDate": this.startDate,
          "travellerInformation": this.travellerInfo,
          "travelllerDetails": this.insuredPersonArray,
          "visitorsToCanada": this.selectedQuestionAns1,
          "purchaserInformation":{
            "country": "",
            "emailAddress": this.purchaseEmail,
            "firstName": this.purchaserFirstName,
            "language": this.selectedQuestionlanguages1,
            "lastName": this.purchaserLastName,
            "phoneNumber1": this.purchasePhone1,
            "phoneNumber2": this.purchasePhone2,
            "postalCode": this.purchasePostalCode,
            "province": this.purchaseProvince,
            "purchaserAddress": {
              "address1": this.purchaserAddress1,
              "address2": this.purchaserAddress2,
              "city": this.purchaseCity,
              "postalCode": this.purchasePostalCode
          }}
         }
        // this.restService.callPostService(this.config.postApistep3, request).subscribe((data: any) => {
      this.base.callPostService(this.config.postApistep3, request).subscribe((data: any) => {
        // window.scrollTo(0, 0);
        // this.showChangePolicy=true;
        // this.showChangePolicyStepOne=false;
        // this.showChangePolicyStepTwo=true;
        // this.showChangePolicyStepTwoB=false;
        // this.showChangePolicyStepThree=true;
        // this.showChangePolicyStepThreeAdminFee=false;
        // this.showChangePolicyStepFour=false;
        // this.showChangePolicyStepFive=false;
        // this.showSearchedPolicy=false;
        // this.showPolicyDetails=false;
        // this.showPolicySearch=false;
        // this.showRefundPolicy=false;
      //this.step2SaveApiCall()
      // if(this.intStudPlanChecked==true || this.intStudPlanChecked1==true){
      //   this.showQuestionnaireQue=false;
      //   this.showDeclarationQuestionnaire=false;
      //   this.showChooseQuote=false;
      //   this.showIntStudPlan=true;
      //   this.showIntStudPlanStep1=false;
      //   this.showIntStudPlanPlanOption=false;
      //   this.showQuestionnaire=false;
      //   this.showQuestionnaireQue=false;
      //   this.showContactInfo=false;
      //   this.showPayment=true;
      //   this.showPaymentsDetails=false;
      // }
      // if(this.studAccidentIncChecked==true){
      //   this.showQuestionnaireQue=false;
      //   this.showDeclarationQuestionnaire=false;
      //   this.showChooseQuote=false;
      //   this.showIntStudPlan=true;
      //   this.showIntStudPlanStep1=false;
      //   this.showIntStudPlanPlanOption=false;
      //   this.showQuestionnaire=false;
      //   this.showQuestionnaireQue=false;
      //   this.showContactInfo=false;
      //   this.showPayment=true;
      //   this.showPaymentsDetails=false;
      // }
      //this.paymentCall();
      // this.step2SaveApiCall()
        // localStorage.removeItem('selectedQuestionprovince1');
        // localStorage.removeItem('selectedQuestionlanguages1');
        // setTimeout(() =>
        // {
        // this.finalStageTransactionCall();
        // },
        // 8000);
           }, error => {{
            if (error.status == 400) {
            }
          }
        }, () => { });
      }

     }

purchaseProvinceFlag: boolean=false;
NonResidentSelected: boolean=false;
comment: any;
beneficiary: any;
agentNote: any;
onProvinceClick(){
  this.purchaseProvinceFlag=false;
  if(this.purchaseProvince == "Non-Resident of Canada" || this.purchaseProvince== "Non Resident of Canada"){
    this.NonResidentSelected=true
  }else{
    this.NonResidentSelected=false;
  }
  }
  insuredPersonArray=[];
  insuredPerson(){
    var obj={};
    obj["firstName"]=""
    obj["lastName"]=""
    obj["insitute"]=""
    obj["homeCountry"]=""
    this.insuredPersonArray.push(obj);

  }
  declarationErrorFlag: boolean=true;
  onClickDeclaration(event){
    var flagCheck = event.target.checked;
    if(flagCheck==true){
    this.declarationErrorFlag=false;
    }else{
      this.declarationErrorFlag=true;

    }
        }

  step2SaveApiCall(){
    var flag=true;
    if(this.declarationErrorFlag == true){flag=false; this.declarationErrorFlag=true}else{flag=true;this.declarationErrorFlag=false}
    if(flag){
    if(this.travellerInfo.length==2){

      this.insuredPerson();
    }
    if(this.travellerInfo.length==3){
      this.insuredPerson();
      this.insuredPerson();
    }
    if(this.travellerInfo.length==4){
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
    }
    if(this.travellerInfo.length==5){
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
    }
    if(this.travellerInfo.length==6){
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
    }
    if(this.travellerInfo.length==7){
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
    }
    if(this.travellerInfo.length==8){
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
    }
    if(this.travellerInfo.length==9){
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
      this.insuredPerson();
    }
      if (flag == true) {

        const request =
        {
          "agentId": this.agentId,
          "declaration": true,
          "deductableOptions": [
            {
              "amount": 0,
              "createdAt": "2022-04-27T05:08:15.125Z",
              "createdBy": "string",
              "id": 0,
              "lastModifiedBy": "string",
              "option": "string",
              "reduceAmount": 0,
              "updatedAt": "2022-04-27T05:08:15.125Z"
            }
          ],
          "language": this.selectedQuestionlanguages1,
          "noOfDays": this.calculatedDays,
          "optionalInformation": {
            "agentNote": "string",
            "beneficiary": "string",
            "comment": "string"
          },
          "paymentInformation": {
            "amount": 0,
            "cardNumber": "string",
            "cardType": "string",
            "cvv": "string",
            "expiryDate": "string"
          },
          "primaryAddress": {
            "address1": "string",
            "address2": "string",
            "city": "string",
            "postalCode": "string",
            "province":"string"
          },
          "purchaserAddressSame": true,
          "questionsansers": this.questionAnsArray,
          "residentOf": this.selectedQuestionprovince1,
          "returnDate": this.expiryDate,
          "secondaryAddress": {
            "address1": "string",
            "address2": "string",
            "city": "string",
            "postalCode": "string",
            "province":"string"
          },
          "selectedPlan": this.selectedPlanSend,
          "startDate": this.startDate,
          "travellerInformation": this.travellerInfo,
          "travelllerDetails": [
            {
              "arrivalDateInCanada": "",
              "country": "",
              "dateOfBirth": "",
              "dayTimePhone": "",
              "departureCity": "",
              "emailAddress": "",
              "firstName": "",
              "insitute": "",
              "language": "",
              "lastName": ""
            }
          ],
          "visitorsToCanada": this.selectedQuestionAns1,
          "purchaserInformation":{
            "country": "",
            "emailAddress": "",
            "firstName": "",
            "language": "",
            "lastName": "",
            "phoneNumber1": "",
            "phoneNumber2": "",
            "postalCode": "",
            "province": "",
            "purchaserAddress": {
              "address1": "",
              "address2": "",
              "city": "",
              "postalCode": ""
          }}
         }
          this.base.callPostService(this.config.postApistep2, request).subscribe((data: any) => {
            this.onClickQuestionnaireProceed();
           }, error => {

        }, () => { });
      }
    }
  }

  questionAnsArray: any[]=[];
  selectedPlanSend=[];
  onClickQuestionnaireProceed(){
    window.scrollTo(0, 0);

  }
  onCityClick(){
    this.purchaseCityFlag=false;
    }
    onEmailClick(){
      this.purchaseEmailFlag=false;
      }
      onPhoneClick1(){
      this.purchasePhone1Flag=false;
      }
      onPostalCodeClick(){
      this.purchasePostalCodeFlag=false;
      }
      callAddressApiCall1(){
        this.purchaserAddress1Flag=false;
        this.showAddressResults1=true;
        this.purchaseProvince=false;
        this.purchasePostalCode=false;
        this.purchaseCity=false;
        this.user.getAddressCanada(this.purchaserAddress1).subscribe((data:any) =>{
         this.getAddress1 = data.Items;
        },error=>{{
        //handle Exception from Server 404,401
        }},()=>{});
      }
      getSelectedAddress1: any[]=[];
  onClickSearchResult1(item){
  this.purchaserAddress1=item.Text;
  this.showAddressResults1=false;
  this.user.getAddressCanadaSelected(item.Id).subscribe((data:any) =>{
    this.getSelectedAddress1 = data.Items;
    this.purchaseCity=this.getSelectedAddress1[0].City;
    this.purchasePostalCode=this.getSelectedAddress1[0].PostalCode;
    this.purchaseProvince=this.getSelectedAddress1[0].ProvinceName;
    // this.purchaseCityFlag=false;
    // this.purchasePostalCodeFlag=false;
    // this.purchaseProvinceFlag=false;
   },error=>{{
   }},()=>{})
}
provincesArray:any[]=[];
getAllProvinces(){
  this.user.getProvincesBToB().subscribe((data:any) =>{
   this.provincesArray = data.data;
  },error=>{{
  }},()=>{});
}
// onSaveQuote3(){
//   var flag=true;
//   if(!this.quoteName){this.quoteNameFlag=true;flag=false}else{this.quoteNameFlag=false;flag=true}
//   if (flag == true) {
//     const request =
//     {
//       "agentId": this.agentId,
//       "declaration": true,
//       "deductableOptions": [
//         {
//           "amount": 0,
//           "createdAt": "2022-04-27T05:08:15.125Z",
//           "createdBy": "string",
//           "id": 0,
//           "lastModifiedBy": "string",
//           "option": "string",
//           "reduceAmount": 0,
//           "updatedAt": "2022-04-27T05:08:15.125Z"
//         }
//       ],
//       "language": this.selectedQuestionlanguages1,
//       "noOfDays": this.calculatedDays,
//       "optionalInformation": {
//         "agentNote": this.comment,
//         "beneficiary": this.beneficiary,
//         "comment": this.agentNote
//       },
//       "paymentInformation": {
//         "amount": 0,
//         "cardNumber": "string",
//         "cardType": "string",
//         "cvv": "string",
//         "expiryDate": "string"
//       },
//       "primaryAddress": {
//         "address1": "",
//         "address2": "",
//         "city": "",
//         "postalCode": "",
//         "province": ""
//       },
//       "quoteDescriptions": this.quoteDescriptions,
//       "quoteName": this.quoteName,
//       "purchaserAddressSame": true,
//       "questionsansers": this.questionAnsArray,
//       "residentOf": this.selectedQuestionprovince1,
//       "returnDate": this.expiryDate,
//       "secondaryAddress": {
//         "address1": "string",
//         "address2": "string",
//         "city": "string",
//         "postalCode": "string",
//         "province":"string"
//       },
//       "selectedPlan": this.selectedPlanSend,
//       "startDate": this.startDate,
//       "travellerInformation": this.travellerInfo,
//       "travelllerDetails": this.insuredPersonArray,
//       "visitorsToCanada": this.selectedQuestionAns1,
//       "purchaserInformation":{
//         "country": "",
//         "emailAddress": this.purchaseEmail,
//         "firstName": this.purchaserFirstName,
//         "language": this.selectedQuestionlanguages1,
//         "lastName": this.purchaserLastName,
//         "phoneNumber1": this.purchasePhone1,
//         "phoneNumber2": this.purchasePhone2,
//         "postalCode": this.purchasePostalCode,
//         "province": this.purchaseProvince,
//         "purchaserAddress": {
//           "address1": this.purchaserAddress1,
//           "address2": this.purchaserAddress2,
//           "city": this.purchaseCity,
//           "postalCode": this.purchasePostalCode
//       }}
//      }
//   this.base.callPostService(this.config.saveQuote, request).subscribe((data: any) => {
//     this.quoteNameFlag=false;
//     this.saveQuotesPopup=false;
//     this.saveQuotesPopup1=false;
//     this.saveQuotesPopup2=false;
//     this.quoteName="";
//     this.quoteDescriptions=""
//     Swal.fire('',"Quote information saved.",'success');

//        }, error => {{
//         if (error.status == 400) {
//         }
//       }
//     }, () => { });
//   }

//  }
popUpLanguageFlag:boolean=false;
validateLanguage(data){
  if(data != null){
    this.popUpLanguageFlag=true;
  }
}
languagesArray: any=[];
getAllLanguages(){
  this.user.getLanguageBToB().subscribe((data:any) =>{
   this.languagesArray = data.data;
  },error=>{{
  }},()=>{});
}
notValidPhoneNo: string="";
checkPatternWork(){
  var re = /^[0-9-+() ]*$/;
  if (!re.test(this.purchasePhone1.toLowerCase())) {
  this.notValidPhoneNo="Please enter valid Work Phone";
  }else{
    this.notValidPhoneNo=""
  }
  }
  checkConfirmEmail(){
    if(this.purchaseEmail && this.purchaseEmailConfirm){
      if(this.purchaseEmail==this.purchaseEmailConfirm){
        this.confirmEmailMatch = false;
      }else{
        this.confirmEmailMatch = true;
      }
    }

  }
  emailCheck(){
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(this.purchaseEmail.toLowerCase())){
      this.emailNotValid="Please enter valid Email";
    }else{
      this.emailNotValid="";
    }
    }
    printPopup:boolean=false;
    viewPaymentDetailsPopup:boolean=false;
    newNotePopup:boolean=false;
    email:any=[];
    email1:any;
    email2:any;
    emailErrorFlag:boolean=false;
    onRemoveEmailError(){
      this.emailErrorFlag=false;
      }

    onSendEmail(){
      this.email=[];
      if(!this.email1){this.emailErrorFlag=true}else{this.emailErrorFlag=false}
      if(this.emailErrorFlag==false){
        this.printPopup=false;
        this.email.push(this.email1)
        if(this.email2!=null){
        this.email.push(this.email2)}
      this.userservice.getPolicyEmailSend(this.email,this.policyId).pipe().subscribe(data => {
        Swal.fire('','Email sent successfully.','success');
        this.getPolicyByIdSalesAdmin();
        },error=>{
        },()=>{});
    }
  }
    editEffectiveDate:boolean=false;
    editContactInfoName:boolean=false;
    editContactInfoAdderss:boolean=false;
    editContactInfoEmail:boolean=false;
    editContactInfoLanguage:boolean=false;
    editPurchaserInfoName:boolean=false;
    editPurchaserInfoAddress:boolean=false;
    editPurchaserInfoEmail:boolean=false;
    editPurchaserInfoPhoneOne:boolean=false;
    editPurchaserInfoPhoneTwo:boolean=false;
    editPurchaserInfoLanguage:boolean=false;
    updateEffectiveDate(){
      this.editEffectiveDate =! this.editEffectiveDate;
    }
    updateContactInfoName(){
      this.editContactInfoName =! this.editContactInfoName;
    }
    updateContactInfoAdderss(){
      this.editContactInfoAdderss=!this.editContactInfoAdderss;
    }
    updateContactInfoEmail(){
      this.editContactInfoEmail=!this.editContactInfoEmail;
    }
    updateContactInfoLanguage(){
      this.editContactInfoLanguage=!this.editContactInfoLanguage;
    }
    updatePurchaserInfoName(){
      this.editPurchaserInfoName=!this.editPurchaserInfoName;
    }
    updatePurchaserInfoAddress(){
      this.editPurchaserInfoAddress=!this.editPurchaserInfoAddress;
    }
    updatePurchaserInfoEmail(){
      this.editPurchaserInfoEmail=!this.editPurchaserInfoEmail;
    }
    updatePurchaserInfoPhoneOne(){
      this.editPurchaserInfoPhoneOne=!this.editPurchaserInfoPhoneOne;
    }
    updatePurchaserInfoPhoneTwo(){
      this.editPurchaserInfoPhoneTwo=!this.editPurchaserInfoPhoneTwo;
    }
    updatePurchaserInfoLanguage(){
      this.editPurchaserInfoLanguage=!this.editPurchaserInfoLanguage;
    }
    cancelEditPencilIcon(){
      this.editEffectiveDate=false;
      this.editContactInfoName=false;
      this.editContactInfoAdderss=false;
      this.editContactInfoEmail=false;
      this.editContactInfoLanguage=false;
      this.editPurchaserInfoName=false;
      this.editPurchaserInfoAddress=false;
      this.editPurchaserInfoEmail=false;
      this.editPurchaserInfoPhoneOne=false;
      this.editPurchaserInfoPhoneTwo=false;
      this.editPurchaserInfoLanguage=false;
    }
    contactInformation:any;
    purchaserInformation:any;
    contactInfoAddress:any;
    purchaserInfoAddress:any;
    updateContactInfoAddress1:any;
    updateContactInfoAddress2:any;
    updateContactInfoCity:any;
    updateContactInfoPostalCode:any;
    updateContactInfoProvince:any;
    updatePurchaserInfoAddress1:any;
    updatePurchaserInfoAddress2:any;
    updatePurchaserInfoCity:any;
    updatePurchaserInfoPostalCode:any;
    updatePurchaserInfoProvince:any;
    updatePolicyInformation(){
      var flag=true
      
      var errormsg=[];
      if(!this.updatePurchaserInfoAddress1){flag=false;errormsg.push('Purchaser Address1')}else{}
      if(!this.updatePurchaserInfoCity){flag=false;errormsg.push('Purchaser City')}else{}
      if(!this.updatePurchaserInfoPostalCode){flag=false;errormsg.push('Purchaser PostalCode')}else{}
      if(!this.updatePurchaserInfoProvince){flag=false;errormsg.push('Purchaser Province')}else{}
      if(!this.purchaserPhone1){flag=false;errormsg.push('Phone 1')}else{}

      
      if(flag==true){
      var objAddresContact={}
      objAddresContact["address1"]=this.updateContactInfoAddress1;
      objAddresContact["address2"]=this.updateContactInfoAddress2,
      objAddresContact["city"]=this.updateContactInfoCity,
      objAddresContact["postalCode"]=this.updateContactInfoPostalCode,
      objAddresContact["province"]=this.updateContactInfoProvince
      this.contactInfoAddress=objAddresContact;
      var objAddresPurchaser={}
      objAddresPurchaser["address1"]=this.updatePurchaserInfoAddress1;
      objAddresPurchaser["address2"]=this.updatePurchaserInfoAddress2,
      objAddresPurchaser["city"]=this.updatePurchaserInfoCity,
      objAddresPurchaser["postalCode"]=this.updatePurchaserInfoPostalCode,
      objAddresPurchaser["province"]=this.updatePurchaserInfoProvince
      this.purchaserInfoAddress=objAddresPurchaser;
      var obj={}
      obj["address"]=this.contactInfoAddress,
      obj["email"]=this.contactInfoEmail,
      obj["firstName"]=this.contactInfoFirstName,
      obj["language"]=this.contactInfoLanguage,
      obj["lastName"]=this.contactInfoLastName
      this.contactInformation=obj;
      var obj1={}
      obj1["address"]=this.purchaserInfoAddress
      obj1["email"]=this.purchaserEmailAddress,
      obj1["firstName"]=this.purchaserFirstName,
      obj1["language"]=this.purchaserlanguage,
      obj1["lastName"]=this.purchaserLastName,
      obj1["phone1"]=this.purchaserPhone1,
      obj1["phone2"]=this.purchaserPhone2
      this.purchaserInformation=obj1;
      this.userservice.upadtePolicyInformation(this.contactInformation,this.policyId,this.purchaserInformation).pipe().subscribe(data => {
        // Swal.fire('',"Policy updated successfully.",'success');
        this.cancelEditPencilIcon();
        // this.getPolicyByIdSalesAdmin();
        Swal.fire({
   
    text: "Policy updated successfully",
    icon: 'success',
    // showCancelButton: true,
    confirmButtonColor: '#3085d6',
    // cancelButtonColor: '#d33',
    confirmButtonText: 'OK'
  }).then((result) => {
    if (result.isConfirmed) {
      window.location.reload();
    }
  })
        
        },error=>{
        this.newNotePopup=false;
      },()=>{});
    }
    else{
      // Swal.fire('',"Please Check Address Details",'error')
       this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      Swal.fire("", "Please fill following mandatory field" + "<br>" + this.msgfinal, 'warning')
    }
  
      }
    onLogsDetails(){
      // this.showChangePolicy=false;
      // this.showChangePolicyStepOne=false;
      // this.showChangePolicyStepTwo=false;
      // this.showChangePolicyStepTwoB=false;
      // this.showChangePolicyStepThree=false;
      // this.showChangePolicyStepThreeAdminFee=false;
      // this.showChangePolicyStepFour=false;
      // this.showChangePolicyStepFive=false;
      // this.showSearchedPolicy=false;
      // this.showPolicyDetails=false;
      // this.showPolicySearch=false;
      // this.showRefundPolicy=false;
      // this.showAudtiLogs=true;
      this.router.navigateByUrl('/dashboard/sales-admin-policy-audit-logs');
    }
  noteText:any;
  noteType:any;
  openNewNotePopup(){
    this.newNotePopup=true;
    this.getNotesStatus();
    this.noteText=null;
    this.noteType=null;
  }
  addNotesToPolicy(){
    this.newNotePopup=false;
    this.userservice.addNoteInPolicy(this.noteText,this.policyId,this.noteType).pipe().subscribe(data => {
      Swal.fire('',data.message,'success');
      this.getPolicyByIdSalesAdmin();
      },error=>{
      this.newNotePopup=false;
    },()=>{});
  }
  notesSatusData:any=[]
  getNotesStatus(){
    this.userservice.getNotesStatus().pipe().subscribe(data => {
        this.notesSatusData=data.data;
    },error=>{
    },()=>{});
  }
  getPrimaryAddress:any=[];
  callAddressApiCall(item){
    this.getPrimaryAddress=[];
    this.showAddressResults1=true;
    this.user.getAddressCanada1(item).subscribe((data:any) =>{
     this.getPrimaryAddress = data.suggestions;
    },error=>{{
    //handle Exception from Server 404,401
    }},()=>{});
  }
  callAddressApiCall2(item){
    this.getPrimaryAddress=[];
    this.showAddressResults2=true;
    this.user.getAddressCanada1(item).subscribe((data:any) =>{
     this.getPrimaryAddress = data.suggestions;
    },error=>{{
    //handle Exception from Server 404,401
    }},()=>{});
  }
  onClickSearchResultprimary(item){
    // if(item.Type!= "Container"){
    this.updateContactInfoAddress1=item.Text;
    this.showAddressResults1=false;
    this.user.getAddressCanadaSelected(item.action.id).subscribe((data:any) =>{
      this.getSelectedAddress1 = data.features;
      this.updateContactInfoAddress1=this.getSelectedAddress1[0]?.properties?.address_line1;
      this.updateContactInfoAddress2=this.getSelectedAddress1[0]?.properties?.address_line2;
      this.updateContactInfoCity=this.getSelectedAddress1[0]?.properties?.place;
      this.updateContactInfoPostalCode=this.getSelectedAddress1[0]?.properties?.postcode;
      this.updateContactInfoProvince=this.getSelectedAddress1[0]?.properties?.region;
     },error=>{{
     }},()=>{})
    // }
  }
  showAddressResults2:boolean=false;
  onClickSearchResultprimaryPurcheser(item){
    // if(item.Type!= "Container"){
    this.updatePurchaserInfoAddress1=item.Text;
    this.showAddressResults2=false;
    this.user.getAddressCanadaSelected(item.action.id).subscribe((data:any) =>{
      this.getSelectedAddress1 = data.features;

      this.updatePurchaserInfoAddress1=this.getSelectedAddress1[0]?.properties?.address_line1;
      this.updatePurchaserInfoAddress2=this.getSelectedAddress1[0]?.properties?.address_line2;
      this.updatePurchaserInfoCity=this.getSelectedAddress1[0]?.properties?.place;
      this.updatePurchaserInfoPostalCode=this.getSelectedAddress1[0]?.properties?.postcode;
      this.updatePurchaserInfoProvince=this.getSelectedAddress1[0]?.properties?.region;
     },error=>{{
     }},()=>{})
    // }
    // else{
    //   this.updatePurchaserInfoAddress1=item.Text;
    //   this.purchaserAddress1c=item.Id;
    //   this.callAddressApiCallN();
    // }
  }
  callAddressApiCallN(){
    
    // this.purchaserAddress1Flag=false;
    // this.showAddressResults1=true;
    // this.purchaseProvince=false;
    // this.purchasePostalCode=false;
    // this.purchaseCity=false;
    this.user.getAddressCanadaN(this.updatePurchaserInfoAddress1,this.purchaserAddress1c).subscribe((data:any) =>{
     this.getPrimaryAddress = data.Items;
    },error=>{{
    //handle Exception from Server 404,401
    }},()=>{});
  }
  isDisabled: boolean = false;
  goToQuotePurchase(){
    if(this.isDisabled){
      return;
    }
    if(this.hideQuotePurchase!="true"){
      this.router.navigateByUrl('/dashboard/Quotes-Purchase');
    }else{
      Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
  }
  viewmoreIndex(i){
    this.viewMoreIndex=i
  }
  nextClickPolicy(id){
    for(let i=0;i<this.policyDataPrevNext.length;i++){
      if(id == this.policyDataPrevNext[i].id){
        i++;
        localStorage.setItem('tlSalesAdminPolicyAdmin',this.policyDataPrevNext[i].id)
        localStorage.setItem('policyNumber',this.policyDataPrevNext[i].policyNumber)
        this.router.navigateByUrl('/dashboard/policy-details')
      }
      setTimeout(() => {
        window.location.reload()
    },
      50);
    }
  }
  previousClickPolicy(id){
    for(let i=0;i<this.policyDataPrevNext.length;i++){
      if(id == this.policyDataPrevNext[i].id){
        var back = i-1;
        localStorage.setItem('tlSalesAdminPolicyAdmin',this.policyDataPrevNext[back].id)
        localStorage.setItem('policyNumber',this.policyDataPrevNext[back].policyNumber)
        this.router.navigateByUrl('/dashboard/policy-details')
        }
        setTimeout(() => {
          window.location.reload()
      },
      50);
    }
  }
  getLeadAgentsCodes(){
    this.user.getLeadAgentsCodes(this.leadsId).pipe()
    .subscribe(
      data => {
      // console.log(data);
      // this.agentcodedata=[];
    
      // this.agentIdActive=sessionStorage.getItem('agentIdActive');
      for(let i=0;i<data.data.agentCodes.length;i++){
        if(this.agentId==data.data.agentCodes[i].id){
          if(data.data.agentCodes[i].status=="Inactive - New Agency"){
            this.agentIdInactiveNewAgency=true
          }
          else{
            this.agentIdInactiveNewAgency=false
          }
          if(data.data.agentCodes[i].status=="Active" || data.data.agentCodes[i].status=="Primary")
          {
          this.agentIdActive='true'
          }
          else{
            this.agentIdActive='false'
          }
        }
       // this.agentcodedata.push(data.data.agentCodes[i])
        // console.log(this.agentcodedata)
      }
      }, error => {
  
        // if (error.status == 400 || error.status == 417) {
        //   this.error = error.error.data;
        // }
        // else {
        //   this.error = "Something went wrong. Please check username and password.";
        // }
      }, () => { });
    }
    goToSalesHome(){
      if(this.agentIdActive=='true'){
        this.router.navigateByUrl('/dashboard/sales-home');
      }else{
        // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
      }

    }
goToPolicySearch(){
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/policy-search');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }

}
goToSaveQuote(){
  
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/Save-Quotes');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }
}
goToforms(){
  
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/forms');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }
}
goToResources(){
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/resources');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }

}
  getDashboard() {
    //debugger
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
          this.leadStatus=data.data.leads.leadStatus;
          if(this.leadStatus == 'Deactivated'){
            this.isDisabled = true;
          } else{
            this.isDisabled = false;
          }
         }, error => {
        }, () => { });
  }
}